// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_-sm","cls2":"ImpactHubModal-cls2_xPu ImpactHubModal-cls1_-sm"};